// extracted by mini-css-extract-plugin
export default {"forgotWrapper":"forgotpassword_forgotWrapper__wU8Os"};